/* eslint-disable */
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../../components/Button'
import { fetchAssetCategories, fetchDeviceType, fetchDeviceModel, createDevice, addDeviceIndicator, addDeviceParameter, imageUpload } from '../../redux/actionCreators'
import { type AssetCategoriesState } from '../../redux/assetCategoriesSlice'
import { type DeviceTypeState } from '../../redux/deviceTypeSlice'
import { type DeviceModelState } from '../../redux/deviceModelSlice'
import { connect, type ConnectedProps, useSelector, useDispatch } from 'react-redux'
import { type RootState } from '../../../../store'
import { type OperationPermissionState } from '../../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'
import { getOperationPermissions } from '../../../dashboard/redux/actionCreator'
import Link from '@mui/material/Link'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import ArrowBackIos from '@mui/icons-material/ArrowBackIos'
import Typography from '@mui/material/Typography'
import LanguageStrings from '../../../../i18n/locales'
import SelectDeviceType from '../../../../assets/SelectDeviceType.png'
import AddParameters from '../../../../assets/AddParameters.png'
import DeviceInformation from './DeviceInformation'
import AddDeviceParameters from './AddDeviceParameters'
import AddDeviceDummy from '../../../../assets/AddDevice/image.png'
import { type CreateDevicePostRequest } from '../../services/createDeviceService'
import { type CreateDeviceState } from '../../redux/createDeviceSlice'
import Modal from '../../../../components/Modal'
import { CircularProgress, Step, StepLabel, Stepper } from '@mui/material'
import CustomToast from '../ToastComponent'
import { isValidDevicePort, isValidDeviceData, isValidLatLong, isValidSlaveAddress } from '../../../../utils/validator'
import { APIConfiguration } from '../../../../utils/apiConfiguration'
import AuthError from "../../../../components/ErrorComponents/AuthError"
import { type DeviceIndicatorState } from '../../redux/addDeviceIndicatorSlice'
import { type DeviceParameterState } from '../../redux/addDeviceParameterSlice'
import { ImageUploadReset, type ImageUploadState } from '../../redux/imageUploadSlice'
import { type ImageUploadPostRequest } from '../../services/imageUploadService'
import { reset } from '../../redux/createDeviceSlice'
import { useLocation } from 'react-router-dom'
import { indicatorReset } from '../../redux/indicatorSlice'
import { modbusParamsReset } from '../../redux/modbusParamsSlice'
import useRefreshHamburgNotifier from '../../../../customHooks/useRefreshHamburgNotifier'
import { SteperForm } from '../EditDevice/EditDeviceComponent'

const httpStatus = APIConfiguration
const MAX_LENGTH = 100
const APPLICATION_TYPE_MAX_LENGTH = 500
const AddDeviceStrings = LanguageStrings().DeviceManagementCollectionStrings.AddDeviceComponent
const DashboardStrings = LanguageStrings().Dashboard

interface LabelValue {
  label: string
  value: string
}

const AddDevice = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const stateLocation = useLocation()
  const { parentAssetId } = useParams() as { parentAssetId: string }
  const [isDeviceDetailsEnabled, setIsDeviceDetailsEnabled] = React.useState(true)
  const operationPermissions: OperationPermissionState = useSelector(
    (state: RootState) => state.operationPermissions
  )
  const [categoryTypeId, setCategoryTypeId] = React.useState('')
  const [assetType, setAssetType] = React.useState<LabelValue | null>(null)
  const [assetModel, setAssetModel] = React.useState<LabelValue | null>(null)
  const [deviceId, setDeviceId] = React.useState('')
  const [deviceName, setDeviceName] = React.useState('')
  const [deviceNameErrorInit, setDeviceNameErrorInit] = React.useState(false)
  const [serialNumber, setSerialNumber] = React.useState('')
  const [serialNumberErrorInit, setSerialNumberErrorInit] = React.useState(false)
  const [applicationType, setApplicationType] = React.useState('')
  const [applicationTypeErrorInit, setApplicationTypeErrorInit] = React.useState(false)
  const [location, setLocation] = React.useState('')
  const [locationErrorInit, setLocationErrorInit] = React.useState(false)
  const [slaveAddress, setSlaveAddress] = React.useState('')
  const [slaveAddressErrorInit, setSlaveAddressErrorInit] = React.useState(false)
  const [previewImage, setPreviewImage] = React.useState<string | null>(AddDeviceDummy)
  const [showConfirmation, setShowConfirmation] = React.useState(false)
  const [showCreatePopup, setShowCreatePopup] = React.useState(false)
  const [isStdError, setIsStdError] = React.useState(false)
  const [isCustomError, setIsCustomError] = React.useState(false)
  const [isModbusError, setIsModbusError] = React.useState(false)
  const [indicators, setIndicators] = React.useState<any>([])
  const [parameters, setParameters] = React.useState<any>([])
  const [deviceImage, setDeviceImage] = React.useState<any>()
  const [isDeviceCreateInProgress, setIsDeviceCreateInProgress] = React.useState<boolean>(false)
  const [portNumber, setPortNumber] = React.useState('')
  const [portNumberErrorInit, setPortNumberErrorInit] = React.useState(false)
  const { refreshHamburgAction } = useRefreshHamburgNotifier()

  const auth = useAuth()
  const thermalCategory = 'Thermal'
  const { parentSiteId: parentSiteId, deviceAssetId: deviceAssetId, isTcpProtocol: isTcpProtocol, communicationProtocol: communicationProtocol } = stateLocation.state || {};
  
  React.useEffect(() => {
    (parentSiteId === '' || parentSiteId === undefined || parentSiteId === null) && navigate('/site-list')
  }, [parentSiteId])

  React.useEffect(() => {
    if (!operationPermissions.updated) {
      props.getOperationPermissions(auth.user?.profile.sub as string)
    }
    props.fetchAssetCategories()
  }, [])

  React.useEffect(() => {
    if (props.createDeviceState.data != null && props.createDeviceState.data.asset_id) {
      setDeviceId(props.createDeviceState.data.asset_id)
      refreshHamburgAction('Device', 'Create')
      if (deviceImage) {
        props.imageUpload({
          assetId: props.createDeviceState.data.asset_id,
          assetTypeId: assetType?.value,
          locale: 'en_US',
          file: deviceImage
        })
      } else {
        setIsDeviceDetailsEnabled(false)
      }
    }
  }, [props.createDeviceState])

  React.useEffect(() => {
    if (props.assetCategories?.assetCategories != null && props.assetCategories.assetCategories.length > 0) {
      const thermalCat = props.assetCategories.assetCategories.find(
        (cat: any) => cat.category_type_name === thermalCategory
      )
      if (thermalCat != null) {
        setCategoryTypeId(thermalCat.category_type_id)
        props.fetchDeviceType(thermalCat.category_type_id, communicationProtocol)
      }
    }
  }, [props.assetCategories])

  React.useEffect(() => {
    setIsDeviceCreateInProgress(false)
    if (props.imageUploadState.isLoading === false && props.imageUploadState.httpStatus === httpStatus.CREATED_HTTP_STATUS) {
      setIsDeviceDetailsEnabled(false)
    }
  }, [props.imageUploadState])

  React.useEffect(() => {
    return () => {
      setIsDeviceDetailsEnabled(true);
      setCategoryTypeId('');
      setAssetType(null);
      setAssetModel(null);
      setDeviceId('');
      setDeviceName('');
      setDeviceNameErrorInit(false);
      setSerialNumber('');
      setSerialNumberErrorInit(false);
      setApplicationType('');
      setApplicationTypeErrorInit(false);
      setLocation('');
      setLocationErrorInit(false);
      setSlaveAddress('');
      setSlaveAddressErrorInit(false);
      setPreviewImage(AddDeviceDummy);
      setDeviceImage(undefined);
      dispatch(reset());
      dispatch(ImageUploadReset())
      dispatch(indicatorReset())
      dispatch(modbusParamsReset())
    };
  }, []);

  function handleBreadCrumbsClick(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void {
    event.preventDefault()
  }

  const handeleCancelClick = (): void => {
    navigate(`/device-list/${parentAssetId}`, { state: { parentSiteId: parentSiteId, deviceAssetId: deviceAssetId }})
  }

  const moveBackOneStep = (): void => {
    setIsDeviceDetailsEnabled(true)
  }

  const addDeviceIndicators = (): void => {
    const indicatorPostData = {
      assetTypeId: assetType?.value,
      assetKpiConfigs: indicators
    }
    props.addDeviceIndicator(indicatorPostData, deviceId)
    const parameterPostData = {
      assetTypeId: assetType?.value,
      assetParamConfigs: parameters
    }
    props.addDeviceParameter(parameterPostData, deviceId)
  }

  // istanbul ignore next
  const deviceIndicatorSubmitWithFailure = (): JSX.Element => {
    if (props.deviceIndicatorState.httpStatus === httpStatus.CREATED_HTTP_STATUS && props.deviceParameterState.httpStatus === httpStatus.CREATED_HTTP_STATUS) {
      return (
        <Modal buttonTypeNegative='hollow' title={AddDeviceStrings.SuccessfullyAdded} LabelPositive={AddDeviceStrings.okay}
          onClickPositive={() => { setShowCreatePopup(false), handeleCancelClick() }}
          onClose={() => { setShowCreatePopup(false), handeleCancelClick() }}>
          <p style={{ paddingTop: '1.2em' }}>{AddDeviceStrings.DeviceHasBeenCreated}</p>
        </Modal>
      )
    } else if (props.deviceIndicatorState.isLoading || props.deviceParameterState.isLoading) {
      return (
        <Modal title={AddDeviceStrings.CreatingDevice}>
          <div className='CircularprogressAmi'><CircularProgress /></div>
        </Modal>
      )
    } else if (props.deviceIndicatorState.httpStatus === httpStatus.BAD_REQUEST || props.deviceParameterState.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }} onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {props.deviceIndicatorState.error ?? props.deviceParameterState.error} </p>
        </Modal>
      );
    } else if (props.deviceIndicatorState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS || props.deviceParameterState.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError"><AuthError errorMessage="Unauthorized" /></div>
      )
    } else {
      return (
        <Modal buttonTypeNegative="hollow" title={"Failed"} LabelPositive="Okay"
          onClickPositive={() => { setShowCreatePopup(false) }}
          onClose={() => { setShowCreatePopup(false) }}
        >
          <p style={{ paddingTop: "1.2em" }}> {AddDeviceStrings.AddDeviceError} </p>
        </Modal>
      )
    }
  }

  const handleCreateDevice = (): void => {
    if (deviceId === '') {
      setIsDeviceCreateInProgress(true)
      createDevice()
    } else setIsDeviceDetailsEnabled(false)
  }

  const createDevice = (): void => {
    const CurrentDate = new Date().toISOString()
    const locationArray = location.split(',')
    const postData = {
      type: 'device',
      name: deviceName,
      serial_number: serialNumber !== '' ? serialNumber : null,
      application_type: applicationType,
      install_date: CurrentDate,
      slave_id: slaveAddress,
      asset_type_id: assetType?.value,
      asset_model_id: assetModel?.value,
      asset_category_id: categoryTypeId,
      /* istanbul ignore next */
      latitude: locationArray.length === 2 ? parseFloat(locationArray[0]) : '',
      /* istanbul ignore next */
      longitude: locationArray.length === 2 ? parseFloat(locationArray[1]) : '',
      parent_asset_id: deviceAssetId,
      site_id: parentSiteId,
      modem_id: parentAssetId,
      port: isTcpProtocol ? portNumber : ''
    }
    props.createDevice(postData)
  }
  // istanbul ignore next
  const handleCreateDeviceWithFailure = (): JSX.Element | null => {
    if (props.createDeviceState.isLoading === false && props.createDeviceState.httpStatus === httpStatus.CREATED_HTTP_STATUS) {
      CustomToast({
        type: 'success',
        heading: AddDeviceStrings.SuccessfullyAdded,
        message: AddDeviceStrings.DeviceHasBeenCreated
      })
      setIsDeviceCreateInProgress(false)
      return null
    } else if (props.createDeviceState.isLoading === true) {
      return (
        <Modal title={AddDeviceStrings.CreatingDevice}>
          <div className='CircularprogressAmi'>
            <CircularProgress />
          </div>
        </Modal>
      )
    } else if (props.createDeviceState.isLoading === false && props.createDeviceState?.error !== '') {
      CustomToast({
        type: 'error',
        heading: AddDeviceStrings.AddDeviceError,
        message: props.createDeviceState?.error
      })
      setIsDeviceCreateInProgress(false)
      return null
    }

    return null
  }
  // istanbul ignore next
  const handleFetchCategoryWithFailure = (): JSX.Element | null => {
    if (props.assetCategories.isLoading === false && props.assetCategories.httpStatus === 200) {
      return null
    } else if (props.assetCategories.isLoading === true) {
      return (
        <Modal title={AddDeviceStrings.FetchingAssetTypes}>
          <div className='CircularprogressAmi'>
            <CircularProgress />
          </div>
        </Modal>
      )
    } else if (props.assetCategories.isLoading === false && props.assetCategories?.loadingError !== '') {
      CustomToast({
        type: 'error',
        heading: AddDeviceStrings.Error,
        message: AddDeviceStrings.FetchAssetTypeError
      })
      return null
    }

    return null
  }

  const isDeviceNameNotValid = (): boolean => {
    return (
      !isValidDeviceData(deviceName) || deviceName.length > MAX_LENGTH
    )
  }
  const isSerialNumberNotValid = (): boolean => {
    return (
      (serialNumber !== '' && (!isValidDeviceData(serialNumber) || serialNumber.length > MAX_LENGTH)) || false
    )
  }
  const isapplicationTypeNotValid = (): boolean => {
    return (
      (applicationType !== '' && (!isValidDeviceData(applicationType) || applicationType.length > APPLICATION_TYPE_MAX_LENGTH))
    )
  }
  const isLocationNotValid = (): boolean => {
    return (
      (location !== '' && (!isValidLatLong(location) || location.length === 0)) || false
    )
  }
  const isSlaveAddressNotValid = (): boolean => {
    return (!isValidSlaveAddress(slaveAddress) || slaveAddress.length === 0)
  }
  const isPortNumberNotValid = (): boolean => {
    const port = parseInt(portNumber, 10)
    return !(port > 0 && port <= 65535 && isValidDevicePort(portNumber) && portNumber.length <= 5)
  }
  const shouldDisableNextButton = (): boolean => {
    return (
      isDeviceNameNotValid() ||
      isSerialNumberNotValid() ||
      isapplicationTypeNotValid() ||
      isLocationNotValid() ||
      isSlaveAddressNotValid() ||
      (isTcpProtocol ? isPortNumberNotValid() : false)
    )
  }
  const shouldDisableAddButton = (): boolean => {
    return (
      isStdError || isCustomError || isModbusError
    )
  }

  return (
    <div>
      <div role="presentation" data-testid="breadcrumbs" onClick={handleBreadCrumbsClick} className="AmiHeading">
        <ArrowBackIos className="assetmgmtli" data-testid="breadcrumb-arrow-back" aria-label="navArrow" sx={{ marginTop: '10px' }}
          onClick={() => { navigate(-1) }}
        />
        <Breadcrumbs aria-label='breadcrumb' sx={{ color: '#f0f0f0', fontSize: '12px', marginBottom: '14px', fontFamily: 'Honeywell Sans Web', marginTop: '12px' }}>
          <Link aria-label='navBreadcrumb1' className='assetmgmtli' data-testid="bc-link-1" underline='none' color='inherit' onClick={() => { navigate('/thermal-dashboard') }} >
            {DashboardStrings.HOME}
          </Link>
          <Link aria-label='navBreadcrumb2' className='assetmgmtli' data-testid="bc-link-2" underline='none' color='inherit' onClick={() => { navigate('/site-list') }} >
            {DashboardStrings.SiteManagement}
          </Link>
          <Link aria-label='navBreadcrumb3' className='assetmgmtli' data-testid="bc-link-3" underline='none' color='inherit'
            onClick={() => { navigate(`/thermal-asset-list/${parentSiteId}`) }} >
            {DashboardStrings.AssetManagement}
          </Link>
          <Link aria-label="navBreadcrumb4" className='assetmgmtli' data-testid="bc-link-4" underline="none" color="inherit"
            onClick={() => { navigate(`/gateway-list/${deviceAssetId}`, { state: { parentSiteId } }) }} >
            {DashboardStrings.GatewayManagement}
          </Link>
          <Link aria-label="navBreadcrumb5" className='assetmgmtli' data-testid="bc-link-5" underline="none" color="inherit"
            onClick={() => {
              navigate(`/device-list/${parentAssetId}`, { state: { parentSiteId: parentSiteId, deviceAssetId: deviceAssetId }})
            }}
          >
            {DashboardStrings.DeviceManagement}
          </Link>
          <Typography color="inherit" sx={{ fontSize: '12px', fontFamily: 'Honeywell Sans Web' }}>{DashboardStrings.CreateNewDevice}</Typography>
        </Breadcrumbs>
      </div>
      <div className="ArrowDeviceAdd">
        <div>
          <span data-testid="deviceHistoryDetails" className="deviceMgtDevicelist" style={{ fontSize: '20px', fontWeight: '900', fontStyle: 'normal', lineHeight: '32px', }}>
            {AddDeviceStrings.AddDevice}
          </span>
        </div>
      </div>
      <div>
         <div style={{ display: 'flex', justifyContent: 'center' }}>
            <SteperForm activeStep={isDeviceDetailsEnabled ? 0 : 1} />
          </div>
      </div>
      <div>
        {isDeviceDetailsEnabled
          ? (
            <DeviceInformation
              assetModel={assetModel}
              setAssetModel={setAssetModel}
              assetType={assetType}
              setAssetType={setAssetType}
              deviceType={props.deviceType.deviceType}
              deviceName={deviceName}
              setDeviceName={setDeviceName}
              deviceNameErrorInit={deviceNameErrorInit}
              setDeviceNameErrorInit={setDeviceNameErrorInit}
              serialNumber={serialNumber}
              setSerialNumber={setSerialNumber}
              serialNumberErrorInit={serialNumberErrorInit}
              setSerialNumberErrorInit={setSerialNumberErrorInit}
              applicationType={applicationType}
              setApplicationType={setApplicationType}
              applicationTypeErrorInit={applicationTypeErrorInit}
              setApplicationTypeErrorInit={setApplicationTypeErrorInit}
              location={location}
              setLocation={setLocation}
              locationErrorInit={locationErrorInit}
              setLocationErrorInit={setLocationErrorInit}
              slaveAddress={slaveAddress}
              setSlaveAddress={setSlaveAddress}
              slaveAddressErrorInit={slaveAddressErrorInit}
              setSlaveAddressErrorInit={setSlaveAddressErrorInit}
              previewImage={previewImage}
              setPreviewImage={setPreviewImage}
              deviceImage={deviceImage}
              setDeviceImage={setDeviceImage}
              deviceId={deviceId}
              portNumber={portNumber}
              setPortNumber={setPortNumber}
              portNumberErrorInit={portNumberErrorInit}
              setPortNumberErrorInit={setPortNumberErrorInit}
              isTcpProtocol={isTcpProtocol}
            />
          )
          : (
            <AddDeviceParameters assetId={deviceId} assetTypeId={
              /* istanbul ignore next */
              assetType?.value ?? ''
            }
              setIsStdError={setIsStdError} setIsCustomError={setIsCustomError} setIsModbusError={setIsModbusError}
              setIndicators={setIndicators} setParameters={setParameters} indicators={indicators} parameters={parameters}
            />
          )}
      </div>
      <div 
        style={{
          height: '80px',
          backgroundColor: '#272727',
          margin: '50px 0 10px 0',
          borderRadius: 10,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0 1em'
        }}
      >
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          {isDeviceDetailsEnabled
            ? (
              <>
                <Button className='AddDeviceCancelButton' data-testid="cancel-btn-click" onClick={() => { handeleCancelClick() }}>
                  {AddDeviceStrings.Cancel}
                </Button>
                <Button
                  className={`${shouldDisableNextButton() ? 'btn-disabled' : ''}`}
                  dataTestId="next-btn-click"
                  onClick={() => {
                    handleCreateDevice()
                  }}
                  disabled={shouldDisableNextButton()}
                >
                  {AddDeviceStrings.Next}
                </Button>
              </>
            )
            : (
              <>
                <Button dataTestId="back-btn" className='AddDeviceCancelButton' onClick={moveBackOneStep}>
                  {AddDeviceStrings.Back}
                </Button>
                <Button
                  className={
                    /* istanbul ignore next */
                    `${shouldDisableAddButton() ? 'btn-disabled' : ''}`
                  } dataTestId="add-device-btn"
                  onClick={() => { setShowConfirmation(true) }} disabled={shouldDisableAddButton()}
                >
                  {AddDeviceStrings.AddDevice}
                </Button>
              </>
            )}
        </div>
      </div>

      {isDeviceCreateInProgress && handleCreateDeviceWithFailure()}
      {props.assetCategories.isLoading && handleFetchCategoryWithFailure()}
      {showConfirmation &&
        <Modal buttonTypeNegative='hollow' title={AddDeviceStrings.AddDevice} LabelNegative={AddDeviceStrings.Cancel} LabelPositive={AddDeviceStrings.Confirm} onClickPositive={() => {
          setShowConfirmation(false), setShowCreatePopup(true), addDeviceIndicators()
        }} onClose={() => { setShowConfirmation(false) }} onClickNegative={() => { setShowConfirmation(false) }}>
          <p style={{ paddingTop: '1.2em' }}>{AddDeviceStrings.DeviceAddConfirmation}</p>
        </Modal>
      }
      {
        /* istanbul ignore next */
        showCreatePopup && deviceIndicatorSubmitWithFailure()
      }
    </div>
  )
}

interface DispatchToProps {
  getOperationPermissions: (sub: string) => void
  fetchAssetCategories: () => void
  fetchDeviceType: (categoryTypeId: string, communicationProtocol: string) => void
  fetchDeviceModel: (deviceTypeId: string) => void
  createDevice: (createDevicePostRequest: CreateDevicePostRequest) => void
  addDeviceIndicator: (addDeviceIndicatorRequest: any, assetId: string) => void
  addDeviceParameter: (addDeviceParamRequest: any, assetId: string) => void
  imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => {
  return {
    getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub)),
    fetchAssetCategories: () => dispatch(fetchAssetCategories()),
    fetchDeviceType: (categoryTypeId: string, communicationProtocol: string) => dispatch(fetchDeviceType(categoryTypeId, communicationProtocol)),
    fetchDeviceModel: (deviceTypeId: string) => dispatch(fetchDeviceModel(deviceTypeId)),
    createDevice: (createDevicePostRequest: CreateDevicePostRequest) => dispatch(createDevice(createDevicePostRequest)),
    addDeviceIndicator: (addDeviceIndicatorRequest: any, assetId: string) => dispatch(addDeviceIndicator(addDeviceIndicatorRequest, assetId)),
    addDeviceParameter: (addDeviceParamRequest: any, assetId: string) => dispatch(addDeviceParameter(addDeviceParamRequest, assetId)),
    imageUpload: (imageUploadPostRequest: ImageUploadPostRequest) => dispatch(imageUpload(imageUploadPostRequest))
  }
}

interface StateToProps {
  assetCategories: AssetCategoriesState
  deviceType: DeviceTypeState
  deviceModel: DeviceModelState,
  createDeviceState: CreateDeviceState,
  deviceIndicatorState: DeviceIndicatorState,
  deviceParameterState: DeviceParameterState,
  imageUploadState: ImageUploadState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  assetCategories: state.assetCategories,
  deviceType: state.deviceType,
  deviceModel: state.deviceModel,
  createDeviceState: state.createDeviceState,
  deviceIndicatorState: state.deviceIndicatorState,
  deviceParameterState: state.deviceParameterState,
  imageUploadState: state.imageUploadState
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(AddDevice)
